/********************************************************************************
 * Copyright (c) 2021 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const size2json = (size) => ({
	h: size.getHeight().toJSON(),
	w: size.getWidth().toJSON()
});
const coord2json = (coord) => ({
	x: coord.getX().toJSON(),
	y: coord.getY().toJSON()
});
const containersize2json = (container) => ({
	split: container.getMessageList().getHeight().getValue(),
	width: container.getWidth().getValue()
});


export const pinInfo = () => {
	const path = ['jsg', 'pin'];
	return (item) => ({
		path,
		value: { p: coord2json(item.getPin().getCoordinate()), lp: coord2json(item.getPin().getLocalCoordinate()) }
	});
};

export const sizeInfo = () => {
	const path = ['jsg', 'size'];
	return (item) => ({ path, value: size2json(item.getSize()) });
};

export const splitterInfo = () => (container) => {
	return {
		path: ['jsg', container.getItemType()],
		value: containersize2json(container)
	};
};

export const typeInfo = () => {
	const path = ['jsg', 'type'];
	return (stsContainer) => ({
		path,
		value: stsContainer.properties.sheetType
	});
};
export const visibleInfo = () => {
	const path = ['jsg', 'visible'];
	return (sheet) => ({
		path,
		value: sheet.isVisible
	});
};

export const sheetOrderInfo = () => {
	const path = ['jsg', 'sheetorder'];
	const ids = (streamsheets = []) => streamsheets.map((sheet) => sheet.properties.sheetId);
	return (container) => ({ path, value: ids(container.streamSheetsModel) });
};
export const activeSheetsInfo = () => {
	const path = ['jsg', 'activesheets'];
	return (container) => ({
		path,
		value: [container.leftSheetContainer.activeSheetIndex, container.rightSheetContainer.activeSheetIndex]
	});
};

export const getCustomInfos = (...infoFns) => (item) => infoFns.map((fn) => fn(item));
